var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoImageOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4501,
    cy: 29.3995,
    rx: 11.6161,
    ry: 1.22275,
    fill: "#351771"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0403 11.3669C29.8365 8.00439 27.3502 1.52424 16.5901 1.27927C11.3934 1.16097 8.03081 3.72208 3.75118 12.2812C3.13981 14.1154 2.22275 15.9496 1.61137 20.5349C1.64683 21.9624 1 24.0071 1 25.4259C1 26.3429 3.75118 25.7316 5.58531 27.2627C7.04683 28.4827 9.00815 28.1593 10.785 28.7939C15.0646 30.3223 15.676 28.7939 19.0386 28.7939C22.4011 28.7939 26.0664 26.6514 28.5149 24.2086C30.3638 22.3639 30.346 20.8433 31.263 18.0921C31.9967 15.8912 30.346 12.5897 30.0403 11.3669Z",
    fill: "#FBE54D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5901 1.27927L16.5796 1.73769L16.5901 1.27927ZM30.0403 11.3669L29.5826 11.3947L29.5852 11.437L29.5954 11.4782L30.0403 11.3669ZM31.263 18.0921L30.828 17.9471L30.828 17.9471L31.263 18.0921ZM28.5149 24.2086L28.8387 24.5332L28.8387 24.5332L28.5149 24.2086ZM10.785 28.7939L10.6308 29.2257L10.6308 29.2257L10.785 28.7939ZM3.75118 12.2812L3.34106 12.0762L3.32649 12.1053L3.31618 12.1363L3.75118 12.2812ZM1.61137 20.5349L1.15687 20.4743L1.15209 20.5101L1.15298 20.5463L1.61137 20.5349ZM5.58531 27.2627L5.87916 26.9107L5.87916 26.9107L5.58531 27.2627ZM16.5796 1.73769C21.8634 1.85797 25.051 3.50452 26.9433 5.47188C28.8445 7.44836 29.4858 9.79777 29.5826 11.3947L30.498 11.3392C30.391 9.57356 29.6872 7.00162 27.6043 4.83614C25.5125 2.66155 22.0769 0.945535 16.6005 0.820861L16.5796 1.73769ZM29.5954 11.4782C29.6791 11.8128 29.8509 12.2777 30.0322 12.7798C30.2183 13.2953 30.4257 13.8786 30.6006 14.489C30.957 15.7325 31.1474 16.989 30.828 17.9471L31.698 18.2371C32.1123 16.9943 31.8442 15.4996 31.4822 14.2364C31.298 13.5935 31.0812 12.9846 30.8947 12.4684C30.7035 11.9388 30.5543 11.5325 30.4851 11.2557L29.5954 11.4782ZM30.828 17.9471C29.8734 20.8111 29.938 22.141 28.191 23.8839L28.8387 24.5332C30.7897 22.5867 30.8186 20.8755 31.698 18.2371L30.828 17.9471ZM28.191 23.8839C25.7868 26.2825 22.2314 28.3353 19.0386 28.3353V29.2524C22.5708 29.2524 26.3459 27.0202 28.8387 24.5332L28.191 23.8839ZM19.0386 28.3353C17.3075 28.3353 16.1997 28.739 15.1778 28.9152C14.1561 29.0913 13.0133 29.1028 10.9392 28.362L10.6308 29.2257C12.8363 30.0134 14.1391 30.0248 15.3336 29.8189C16.5279 29.613 17.407 29.2524 19.0386 29.2524V28.3353ZM4.16131 12.4863C6.29329 8.22238 8.16975 5.51134 10.1211 3.8778C12.0481 2.26453 14.0745 1.68066 16.5796 1.73769L16.6005 0.820861C13.9089 0.759585 11.6557 1.39711 9.53238 3.17462C7.43333 4.93185 5.4887 7.78095 3.34106 12.0762L4.16131 12.4863ZM1.45853 25.4259C1.45853 24.7673 1.60998 23.9484 1.77015 23.0655C1.92516 22.211 2.08889 21.2935 2.06976 20.5235L1.15298 20.5463C1.16931 21.2038 1.02735 22.0224 0.867815 22.9018C0.713429 23.7529 0.541469 24.6657 0.541469 25.4259H1.45853ZM2.06588 20.5955C2.66992 16.0652 3.56634 14.2859 4.18619 12.4262L3.31618 12.1363C2.71328 13.945 1.77558 15.8339 1.15687 20.4743L2.06588 20.5955ZM10.9392 28.362C10 28.0266 8.9876 27.9381 8.14316 27.7957C7.26786 27.6481 6.51318 27.44 5.87916 26.9107L5.29146 27.6147C6.11896 28.3055 7.07569 28.5457 7.99065 28.7C8.93646 28.8595 9.79312 28.9265 10.6308 29.2257L10.9392 28.362ZM5.87916 26.9107C4.85751 26.0578 3.59696 25.8148 2.6804 25.6617C2.19492 25.5806 1.84592 25.5303 1.60359 25.4495C1.48617 25.4103 1.44413 25.379 1.43575 25.3711C1.43487 25.3703 1.44292 25.3779 1.45025 25.3943C1.45366 25.402 1.45592 25.4094 1.45722 25.4158C1.45785 25.4189 1.45818 25.4214 1.45836 25.4231C1.45844 25.424 1.45849 25.4247 1.45851 25.4252C1.45852 25.4254 1.45853 25.4256 1.45853 25.4257C1.45852 25.4253 1.45853 25.4262 1.45853 25.4258C1.45852 25.4254 1.45853 25.4263 1.45853 25.4259H0.541469C0.541469 25.674 0.641946 25.8836 0.80784 26.0395C0.957084 26.1797 1.14431 26.263 1.31347 26.3194C1.64431 26.4298 2.09773 26.4942 2.52932 26.5663C3.44688 26.7195 4.47899 26.9364 5.29146 27.6147L5.87916 26.9107Z",
    fill: "#351771"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5951 5.03715C25.1496 1.36891 18.0169 1.06322 14.7562 1.36891C13.8391 1.87837 11.7604 3.0807 10.7822 3.81435C9.55948 4.73141 7.11402 9.31672 6.50264 11.4565C5.89127 13.5963 6.80833 16.0418 7.72539 17.5703C8.64245 19.0987 12.9221 23.3783 14.7562 24.6011C16.5903 25.8238 21.787 26.4352 23.3154 26.7409C24.8439 27.0466 27.5951 24.9068 29.4292 22.767C30.8965 21.0551 31.2633 16.3475 31.2633 14.2077C31.0595 12.6793 30.0406 8.7054 27.5951 5.03715Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 1.22275
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.647 14.1182C19.1579 13.6291 14.1447 16.7677 12.3105 19.3151C13.5333 21.1492 16.8959 22.9832 18.1186 23.2889C19.3414 23.5946 20.2584 14.7296 19.647 14.1182Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.917062
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9528 14.1184C19.5691 13.5428 23.996 18.2475 25.7606 20.8435C25.4055 22.6686 17.1861 23.5242 18.4244 23.2891C18.7301 23.231 20.5642 15.0354 19.9528 14.1184Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.917062
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0354 13.5063C19.523 13.9969 14.7561 15.9518 12.3106 19.3144C10.4762 17.7859 9.27926 13.9184 8.97731 12.6947C8.67535 11.4711 18.4259 12.8931 19.0354 13.5063Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.917062
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.953 13.5067C19.3683 13.8762 23.9735 17.0423 25.6079 20.8655C27.4643 20.9707 29.7351 14.4239 28.5123 14.4239C26.555 14.4239 20.6839 13.0447 19.953 13.5067Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.917062
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0361 13.2012C18.4614 13.586 15.1997 8.6188 13.8948 5.76391C14.5506 4.02411 18.083 3.78742 19.3418 3.72482C20.6006 3.66223 19.7545 12.72 19.0361 13.2012Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.917062
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5081 13.0887C19.0201 13.5788 24.6351 9.58206 26.87 7.37782C26.8758 5.51855 18.6193 3.3247 19.7884 3.79567C20.077 3.91195 20.2859 12.3077 19.5081 13.0887Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.917062
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7296 13.2011C19.3681 13.4672 15.5852 9.33244 13.8386 5.55917C12.2556 6.90962 8.94791 8.92164 8.94791 12.2842C8.94791 12.6217 15.0615 11.6727 18.7296 13.2011Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.917062
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9526 12.895C21.3056 12.4547 24.8436 8.30968 26.9834 7.6984C28.8248 7.95544 29.9302 14.1602 28.6698 14.1602C26.9833 14.1602 19.1304 13.1626 19.9526 12.895Z",
    fill: "#FBE54D",
    stroke: "#351771",
    strokeWidth: 0.917062
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5712 12.6888C20.5712 12.1997 18.7371 11.9092 18.7371 13.3001C18.6141 14.523 20.0209 14.523 20.2655 14.523H20.2655C20.8768 14.523 20.5712 13.3001 20.5712 12.6888Z",
    fill: "#351771",
    stroke: "#351771",
    strokeWidth: 0.917062
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.41995,
    cy: 25.4287,
    r: 0.305687,
    fill: "#351771"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.0879,
    cy: 26.6494,
    r: 0.305687,
    fill: "#351771"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.97366,
    cy: 26.0401,
    r: 0.305687,
    fill: "#351771"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.36233,
    cy: 26.0381,
    r: 0.305687,
    fill: "#351771"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.751,
    cy: 26.0381,
    r: 0.305687,
    fill: "#351771"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52834,
    cy: 22.3692,
    r: 0.305687,
    fill: "#351771"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.36233,
    cy: 23.5947,
    r: 0.305687,
    fill: "#351771"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.97366,
    cy: 22.9805,
    r: 0.305687,
    fill: "#351771"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.751,
    cy: 22.3692,
    r: 0.305687,
    fill: "#351771"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.36233,
    cy: 21.7578,
    r: 0.305687,
    fill: "#351771"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52834,
    cy: 21.7578,
    r: 0.305687,
    fill: "#351771"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.13967,
    cy: 21.1465,
    r: 0.305687,
    fill: "#351771"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.13967,
    cy: 19.3125,
    r: 0.305687,
    fill: "#351771"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52834,
    cy: 22.9834,
    r: 0.305687,
    fill: "#351771"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.91702,
    cy: 22.9805,
    r: 0.305687,
    fill: "#351771"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.13967,
    cy: 23.5918,
    r: 0.305687,
    fill: "#351771"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.13967,
    cy: 24.8145,
    r: 0.305687,
    fill: "#351771"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.751,
    cy: 25.4258,
    r: 0.305687,
    fill: "#351771"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.91702,
    cy: 23.5918,
    r: 0.305687,
    fill: "#351771"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.91702,
    cy: 22.3692,
    r: 0.305687,
    fill: "#351771"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52834,
    cy: 24.2061,
    r: 0.305687,
    fill: "#351771"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.19631,
    cy: 21.1465,
    r: 0.305687,
    fill: "#351771"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.61137,
    cy: 25.1202,
    r: 0.611374,
    fill: "#351771"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.751,
    cy: 24.2031,
    r: 0.305687,
    fill: "#351771"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52834,
    cy: 25.4287,
    r: 0.305687,
    fill: "#351771"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.19631,
    cy: 22.3692,
    r: 0.305687,
    fill: "#351771"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.36233,
    cy: 24.8174,
    r: 0.305687,
    fill: "#351771"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.97366,
    cy: 24.2031,
    r: 0.305687,
    fill: "#351771"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.97366,
    cy: 21.1465,
    r: 0.305687,
    fill: "#351771"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.36233,
    cy: 20.5352,
    r: 0.305687,
    fill: "#351771"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.97366,
    cy: 19.9239,
    r: 0.305687,
    fill: "#351771"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.751,
    cy: 19.9239,
    r: 0.305687,
    fill: "#351771"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52834,
    cy: 20.5352,
    r: 0.305687,
    fill: "#351771"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.91702,
    cy: 24.2031,
    r: 0.305687,
    fill: "#351771"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.19631,
    cy: 24.2031,
    r: 0.305687,
    fill: "#351771"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.19631,
    cy: 24.8145,
    r: 0.305687,
    fill: "#351771"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.58498,
    cy: 25.4258,
    r: 0.305687,
    fill: "#351771"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52834,
    cy: 24.8145,
    r: 0.305687,
    fill: "#351771"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52834,
    cy: 23.5918,
    r: 0.305687,
    fill: "#351771"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.13967,
    cy: 24.2031,
    r: 0.305687,
    fill: "#351771"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.13967,
    cy: 25.4258,
    r: 0.305687,
    fill: "#351771"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.751,
    cy: 24.8145,
    r: 0.305687,
    fill: "#351771"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.36233,
    cy: 25.4258,
    r: 0.305687,
    fill: "#351771"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4502,
    cy: 13.8096,
    rx: 0.611374,
    ry: 0.305687,
    fill: "#351771"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4508,
    cy: 15.0321,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-28.2965 14.4508 15.0321)",
    fill: "#351771"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3571,
    cy: 14.0633,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-28.2965 16.3571 14.0633)",
    fill: "#351771"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5084,
    cy: 9.84236,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(38.0913 14.5084 9.84236)",
    fill: "#351771"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.732,
    cy: 11.065,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(38.0913 15.732 11.065)",
    fill: "#351771"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2857,
    cy: 11.065,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(38.0913 13.2857 11.065)",
    fill: "#351771"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.9361,
    cy: 8.68731,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-64.6969 22.9361 8.68731)",
    fill: "#351771"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.7134,
    cy: 8.07598,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-64.6969 21.7134 8.07598)",
    fill: "#351771"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.1021,
    cy: 10.5193,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-64.6969 21.1021 10.5193)",
    fill: "#351771"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2105,
    cy: 18.4695,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-64.6969 16.2105 18.4695)",
    fill: "#351771"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.0455,
    cy: 16.6326,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-64.6969 18.0455 16.6326)",
    fill: "#351771"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.4332,
    cy: 19.0809,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-64.6969 17.4332 19.0809)",
    fill: "#351771"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3616,
    cy: 8.67675,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-106.424 17.3616 8.67675)",
    fill: "#351771"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5852,
    cy: 10.5088,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-106.424 18.5852 10.5088)",
    fill: "#351771"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5842,
    cy: 8.06542,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-106.424 18.5842 8.06542)",
    fill: "#351771"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5164,
    cy: 15.3414,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(36.9788 25.5164 15.3414)",
    fill: "#351771"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6307,
    cy: 16.4625,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(36.9788 24.6307 16.4625)",
    fill: "#351771"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4598,
    cy: 14.7272,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(36.9788 22.4598 14.7272)",
    fill: "#351771"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.0305,
    cy: 17.8476,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-106.424 21.0305 17.8476)",
    fill: "#351771"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.2532,
    cy: 19.6816,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-106.424 22.2532 19.6816)",
    fill: "#351771"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.03,
    cy: 19.6797,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-84.7774 21.03 19.6797)",
    fill: "#351771"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5134,
    cy: 11.515,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-15 25.5134 11.515)",
    fill: "#351771"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.0681,
    cy: 12.1234,
    rx: 0.611374,
    ry: 0.305687,
    transform: "rotate(-15 23.0681 12.1234)",
    fill: "#351771"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.751,
    cy: 28.4824,
    r: 0.305687,
    fill: "white"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.97366,
    cy: 27.8711,
    r: 0.305687,
    fill: "white"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.58498,
    cy: 27.8711,
    r: 0.305687,
    fill: "white"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.97366,
    cy: 28.4824,
    r: 0.305687,
    fill: "white"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.58498,
    cy: 28.4824,
    r: 0.305687,
    fill: "white"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.36233,
    cy: 27.8711,
    r: 0.305687,
    fill: "white"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.36233,
    cy: 28.4824,
    r: 0.305687,
    fill: "white"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.13967,
    cy: 28.4824,
    r: 0.305687,
    fill: "white"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.30569,
    cy: 28.4824,
    r: 0.305687,
    fill: "white"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.52834,
    cy: 29.0938,
    r: 0.305687,
    fill: "white"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.751,
    cy: 29.0938,
    r: 0.305687,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoImageOnly);
export default __webpack_public_path__ + "static/media/logo-image-only.649b7b670666c4afbfade0c9cd5894d6.svg";
export { ForwardRef as ReactComponent };